import * as Base from '@base';
import { useTranslation } from '@common';
import styles from '../style.module.less';
import type { ReactElement } from 'react';
import type { RowActionProps } from './types';

export function RowAction(props: RowActionProps): ReactElement {
  const [t] = useTranslation();
  const items: Base.MenuProps['items'] = [
    { key: 'add-prev', label: t('在上面添加行'), onClick: onAddPrev },
    { key: 'add-next', label: t('在下面添加行'), onClick: onAddNext }
  ];

  if (props.length > 1) {
    items.push({ key: 'remove', label: t('删除当前行'), onClick: onRemoveRow });
  }

  function onAddPrev(): void {
    props.onAction('add-prev-row', { col: -1, row: props.index });
  }

  function onAddNext(): void {
    props.onAction('add-next-row', { col: -1, row: props.index });
  }

  function onRemoveRow(): void {
    props.onAction('remove-row', { col: -1, row: props.index });
  }

  return (
    <Base.Dropdown placement='bottomLeft' menu={{ items }}>
      <div className={styles.toggle}>
        <span>{props.index + 1}</span>
      </div>
    </Base.Dropdown>
  );
}
